import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "fadeIn": "Backdrop-fadeIn_3rEvC",
  "fadeOut": "Backdrop-fadeOut_20c2R",
  "root": "Backdrop-root_3gEk3"
};
function Backdrop({
  className,
  style,
  onAnimationStart,
  onAnimationEnd,
  innerRef
}) {
  return /*#__PURE__*/_jsx(Base, {
    innerRef: innerRef,
    position: "fixed",
    style: style,
    onAnimationStart: onAnimationStart,
    onAnimationEnd: onAnimationEnd,
    className: clsx(styles.root, className)
  });
}
export default Backdrop;